import { SERVER_URL } from './../config/contants';
import { HEADERS } from './../config/contants';
import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { LocalStorageProvider } from '../providers/local-storage';
import 'rxjs/add/operator/map';

@Injectable()
export class ClubeHistoricoProvider {

  dados: any = [];
  pagina: number = 1;
  hasmore: boolean = false;
  contentHeader: Headers = new Headers(HEADERS);

  constructor(public http: Http, public localStorage: LocalStorageProvider) {

  }

  refresh() {
    this.pagina = 1;
    this.hasmore = false;
    this.dados = [];
  }

  setPage(page) {
    this.pagina = page;
  }

  checkHasmore() {
    return this.hasmore;
  }

  clienteRegistrosNTF(id) {
    return new Promise((resolve, reject) => {
      this.http.post(SERVER_URL + 'clube/clienteRegistrosNTF/', JSON.stringify({ id: id, pagina: this.pagina }), { headers: this.contentHeader })
        .map(res => res.json())
        .subscribe(
        data => {
          this.hasmore = data.hasmore;
          
          this.localStorage.storageSave('registros', data)

          if (this.hasmore) {
            this.setPage(this.pagina + 1);
          }

          resolve(data)
        },
        err => {
          reject(err)
        }
        );
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/clube-historico.ts